import React, { useEffect, useState } from 'react';
import {
  Fab,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from '@mui/material';
import {
  Language as LanguageIcon,
  Check as CheckIcon,
} from '@mui/icons-material';
import {
  initGoogleTranslate,
  getSavedLanguage,
  setLanguage,
  LANGUAGES,
} from '../../utils/googleTranslate';

// Floating language selector, mounted once in App.js so it is visible on
// every page (including public pages rendered outside the layouts). The
// "notranslate" class keeps Google from translating the menu labels.
const LanguageSwitcher = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentLang, setCurrentLang] = useState('en');

  useEffect(() => {
    initGoogleTranslate(); // idempotent — loads the Google script once
    setCurrentLang(getSavedLanguage());
  }, []);

  const handleSelect = (code) => {
    setAnchorEl(null);
    if (code !== currentLang) {
      setLanguage(code); // persists the choice and reloads once
    }
  };

  return (
    <>
      <Tooltip title="Change language" placement="right">
        <Fab
          size="small"
          color="primary"
          aria-label="change language"
          onClick={(e) => setAnchorEl(e.currentTarget)}
          className="notranslate"
          sx={{
            position: 'fixed',
            bottom: 24,
            left: 24,
            zIndex: (theme) => theme.zIndex.modal,
            boxShadow: 3,
          }}
        >
          <LanguageIcon fontSize="small" />
        </Fab>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        className="notranslate"
        MenuListProps={{ dense: true }}
      >
        {LANGUAGES.map((lang) => (
          <MenuItem
            key={lang.code}
            selected={lang.code === currentLang}
            onClick={() => handleSelect(lang.code)}
          >
            <ListItemIcon sx={{ minWidth: 30 }}>
              {lang.code === currentLang && <CheckIcon fontSize="small" color="primary" />}
            </ListItemIcon>
            <ListItemText primary={lang.label} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSwitcher;
